/**
 * Do not edit directly
 * Generated on Wed, 05 Oct 2022 13:01:12 GMT
 */

module.exports = {
  "spinnerBorderWidthXs": "2px",
  "spinnerBorderWidthSm": "3px",
  "spinnerBorderWidthMd": "4px",
  "spinnerBorderWidthLg": "6px",
  "borderWidthSm": "1px",
  "borderRadiusSm": "4px",
  "borderRadiusMd": "8px",
  "borderRadiusLg": "12px",
  "borderRadiusXl": "16px",
  "borderRadius2xl": "20px",
  "borderRadius3xl": "24px",
  "breakpointMobile": "320px",
  "breakpointTablet": "768px",
  "breakpointDesktop": "992px",
  "breakpointLargedesktop": "1200px",
  "colorComplementaryBlue": "#2dddfa",
  "colorDanger100": "#fff5f5",
  "colorDanger200": "#ffe5e7",
  "colorDanger300": "#f0cccc",
  "colorDanger400": "#e09999",
  "colorDanger500": "#ff6b73",
  "colorDanger600": "#ff4d56",
  "colorDanger700": "#ff1a26",
  "colorDanger800": "#b3000a",
  "colorDanger900": "#790007",
  "colorGreyscale100": "#ffffff",
  "colorGreyscale200": "#f9fafc",
  "colorGreyscale300": "#f3f6f9",
  "colorGreyscale400": "#dee8f0",
  "colorGreyscale500": "#abbdd1",
  "colorGreyscale600": "#5978a6",
  "colorGreyscale700": "#455473",
  "colorGreyscale800": "#1e2936",
  "colorGreyscale900": "#0b0f14",
  "colorPrimary100": "#f2f7ff",
  "colorPrimary200": "#dfedff",
  "colorPrimary300": "#87baff",
  "colorPrimary400": "#4d98ff",
  "colorPrimary500": "#0d73ff",
  "colorPrimary600": "#0052ba",
  "colorPrimary700": "#004d91",
  "colorPrimary800": "#0030a6",
  "colorPrimary900": "#0d3073",
  "colorSecondary100": "#fff5f5",
  "colorSecondary200": "#ffe5e7",
  "colorSecondary300": "#f0cccc",
  "colorSecondary400": "#e09999",
  "colorSecondary500": "#ff6b73",
  "colorSecondary600": "#ff4d56",
  "colorSecondary700": "#ff1a26",
  "colorSecondary800": "#b3000a",
  "colorSecondary900": "#790007",
  "colorSuccess100": "#f2fffa",
  "colorSuccess200": "#ddf7ee",
  "colorSuccess300": "#91f6d2",
  "colorSuccess400": "#00e4a9",
  "colorSuccess500": "#00c996",
  "colorSuccess600": "#00ae82",
  "colorSuccess700": "#00946e",
  "colorSuccess800": "#00795a",
  "colorSuccess900": "#004332",
  "colorWarning100": "#fffaf2",
  "colorWarning200": "#fee6bd",
  "colorWarning300": "#fcd289",
  "colorWarning400": "#fbb43a",
  "colorWarning500": "#faa719",
  "colorWarning600": "#df8f05",
  "colorWarning700": "#c57e04",
  "colorWarning800": "#ab6d04",
  "colorWarning900": "#5c3b02",
  "fontFaceLabGrotesque400NormalWoff2": "https://img.airhelp.com/fonts/LabGrotesque-Regular.woff2",
  "fontFaceLabGrotesque500NormalWoff2": "https://img.airhelp.com/fonts/LabGrotesque-Medium.woff2",
  "fontFaceLabGrotesque700NormalWoff2": "https://img.airhelp.com/fonts/LabGrotesque-Bold.woff2",
  "fontFamilyMain": "'Lab Grotesque', sans-serif",
  "fontSizeXs": "0.75rem",
  "fontSizeSm": "0.875rem",
  "fontSizeMd": "1rem",
  "fontSizeLg": "1.125rem",
  "fontSizeXl": "1.375rem",
  "fontSize2xl": "1.5rem",
  "fontSize3xl": "2rem",
  "fontSize4xl": "2.5rem",
  "fontSize5xl": "3rem",
  "fontWeightNormal": 400,
  "fontWeightMedium": 500,
  "fontWeightBold": 700,
  "heightButtonXs": "32px",
  "heightButtonSm": "40px",
  "heightButtonMd": "48px",
  "heightButtonLg": "56px",
  "heightButtonXl": "72px",
  "heightButtonIconSm": "16px",
  "heightButtonIconMd": "20px",
  "heightButtonIconLg": "24px",
  "heightButtonSpinnerXs": "16px",
  "heightButtonSpinnerSm": "20px",
  "heightButtonSpinnerMd": "24px",
  "heightButtonSpinnerLg": "28px",
  "heightButtonSpinnerXl": "32px",
  "heightSpinnerMd": "48px",
  "heightSpinnerLg": "64px",
  "lineHeightNone": 1,
  "lineHeightShort": 1.2,
  "lineHeightBase": 1.5,
  "shadowsNone": "none",
  "shadowsBase": "0px 1px 4px rgba(30, 41, 54, 0.2)",
  "shadowsMd": "0px 4px 12px rgba(30, 41, 54, 0.16)",
  "shadowsLg": "0px 8px 32px rgba(30, 41, 54, 0.12)",
  "shadowsAlt": "4px 8px 26px rgba(182, 190, 209, 0.25)",
  "spacingAuto": "auto",
  "spacing1x": "4px",
  "spacing2x": "8px",
  "spacing3x": "12px",
  "spacing4x": "16px",
  "spacing5x": "20px",
  "spacing6x": "24px",
  "spacing8x": "32px",
  "spacing10x": "40px",
  "spacing12x": "48px",
  "spacing16x": "64px",
  "spacing24x": "96px",
  "spacing32x": "128px"
};